import React from 'react'
import { connect } from 'react-redux';
import EditModal from "../../EditSite/EditModal";
import SiteHistoryModal from "./SiteHistoryModal";
import { Icon, TooltipHost } from '@fluentui/react';
import { attentionMessages } from '../../../GlobalConst/attentionMessages';
import TempAdminsModal from './TempAdminsModal';
import { PermissionRole, ProvisioningStatus } from "../../../GlobalConst/globalEnums";


class MainView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showEditModal: false,
            showHistoryModal: false,
            showTempAdminsModal: false
        }
    }

    showEditModal = () => {
        this.setState({showEditModal: true})
    }

    onCloseEditModal = () => {
        this.setState({showEditModal: false})
    }

    showHistoryModal = () => {
        this.setState({showHistoryModal: true})
    }

    onCloseHistoryModal = () => {
        this.setState({showHistoryModal: false})
    }

    showTempAdminsModal = () => {
        this.setState({showTempAdminsModal: true})
    }

    onCloseTempAdminsModal = () => {
        this.setState({showTempAdminsModal: false})
    }

    render() {
        var attentionIcon = null;
        var attentions = this.props.editedSite.attentions.filter(a => a.isValid);
        if (this.props.editedSite.keepReadOnly) {
            attentions.push({
                type: 'keepReadOnly'
            })
        }
        if(attentions.length) {
            const attentionText = attentions.map((a, i) => <span key={i}>{attentionMessages[a.type]}<br/></span>);
            attentionIcon = <TooltipHost content={attentionText}>
                                <Icon iconName='important' style={iconStyles} />
                            </TooltipHost>
        }

        return (
            <div style={iconContainerStyles}>
                <div>
                    <Icon style={editIconStyles} onClick={this.showEditModal} iconName="edit" />
                    <EditModal 
                        itemId={this.props.editedSite.id} 
                        isModalOpened={this.state.showEditModal} 
                        onCloseModal={this.onCloseEditModal} 
                        callBack={this.props.callBack}
                        isPowerApp={false}
                    />
                </div>
                <div>
                    <Icon style={iconStyles} onClick={this.showHistoryModal} iconName="diagnostic" />   
                    <SiteHistoryModal 
                        siteId={this.props.editedSite.id}
                        title={this.props.editedSite.title} 
                        isModalOpened={this.state.showHistoryModal} 
                        onCloseModal={this.onCloseHistoryModal} 
                    />
                </div>
                {
                    this.props.role === PermissionRole.administrator &&
                    this.props.editedSite.url &&
                    this.props.editedSite.provisioningStatus !== ProvisioningStatus.ms365Archived &&
                    this.props.editedSite.provisioningStatus !== ProvisioningStatus.permanentDeletion &&
                    <div>
                        <Icon style={iconStyles} onClick={this.showTempAdminsModal} iconName="addFriend" />   
                        <TempAdminsModal 
                            site={this.props.editedSite} 
                            isModalOpened={this.state.showTempAdminsModal}
                            onCloseModal={this.onCloseTempAdminsModal}
                        />
                    </div>
                }
                {
                    this.props.editedSite.channels.length > 0 && 
                    <div>
                        <TooltipHost content="This Team has private or shared channels">
                            <Icon style={editIconStyles} iconName="TeamsLogo" />
                        </TooltipHost>
                    </div>
                }
                {
                    this.props.editedSite.litigationHold && 
                    <div>
                        <TooltipHost content="Litigation hold enabled for this site">
                            <Icon style={editIconStyles} iconName="Lock" />
                        </TooltipHost>
                    </div>
                }
                <div>
                    {attentionIcon}
                </div>
            </div>
        );
    }
}

const iconContainerStyles = {
    display: 'flex'
}

const editIconStyles = {
    cursor: 'pointer',
    margin: '1px 5px',
    fontSize: '14px',
    fontWeight: '600'
}

const iconStyles = {
    cursor: 'pointer',
    margin: '0 5px',
    fontSize: '16px',
    fontWeight: '600'
}

const mapStateToProps = state => ({
    role: state.user.role
})

export default connect(mapStateToProps, null)(MainView)


// WEBPACK FOOTER //
// ./src/components/Administration/SiteDetails/MainView.js